import React from 'react';

import Section from '../components/Section/Section';

const Home = () => {
  return (
    <main style={{ flexGrow: 1 }}>
      <Section sectionType="splash">
      </Section>
      <Section sectionType="welcome">
      </Section>
      <Section sectionType="qualifications">
      </Section>
      <Section sectionType="letsmeet">
      </Section>
      <Section sectionType="movingforward">
      </Section>
    </main>
  );
};

export default Home;


